import React from 'react';
import { Link } from 'react-router-dom';
import { Text } from 'atoms';
import { size, tracking, weight } from 'designs';
import { ROUTES } from 'constants/routes';

type HeaderBrandProps = {
  logoSrc: string;
  /** Set only for brands whose mark doesn't already contain their name. */
  wordmark?: string;
  wordmarkUppercase?: boolean;
  wordmarkSize?: string;
  logoHeight?: string;
  label: string;
};

const HeaderBrand: React.FC<HeaderBrandProps> = ({
  logoSrc,
  wordmark,
  wordmarkUppercase = true,
  wordmarkSize = size.small,
  logoHeight,
  label,
}) => {
  return (
    <Link
      className="app-header-brand"
      to={ROUTES.home}
      aria-label={`${label} — home`}
    >
      <img
        src={logoSrc}
        alt=""
        className="app-header-logo"
        style={logoHeight ? { height: logoHeight } : undefined}
      />

      {wordmark && (
        <Text
          size={wordmarkSize}
          weight={weight.semibold}
          tracking={tracking.normal}
          transform={wordmarkUppercase ? 'uppercase' : 'none'}
          align="center"
          className="app-header-wordmark"
        >
          {wordmark}
        </Text>
      )}
    </Link>
  );
};

export default HeaderBrand;
